import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isWithinInterval/index.js';

var require$$55 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$55 as default };
